import React, { useEffect, useRef, useState } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import { FaUserClock } from "react-icons/fa6";
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import TaskProp from '../../Components/Task/TaskProp';
import TaskDetail from '../../Components/Task/TaskDetail';
import TaskConversation from '../../Components/Task/TaskConversation';
import Delete from '../../Components/Shared/Delete';
import ResponsiveList, { CardTitle, CardField, CardActions } from '../../Components/Shared/ResponsiveList';
import { RowHeightOf, NoteLine } from '../../Components/Shared/RowHeight';
import RejectNote from '../../Components/Task/RejectNote';

const { Column, HeaderCell, Cell } = Table;

//--> دلیل برگشت زیر عنوان می نشیند و یک خط به سطر اضافه می کند
const TaskRowHeight = (rowData) =>
    RowHeightOf(rowData, 55) + (rowData && rowData.rejectComment ? NoteLine : 0);

const MyTasks = () => {

    //#region Const

    let navigate = useNavigate();
    const TaskRef = useRef();
    const DetailRef = useRef();
    const ChatRef = useRef();
    const DeleteRef = useRef();
    const PopupRef = useRef();

    const [showDrawer, setShowDrawer] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [showChat, setShowChat] = useState(false);
    const [ShowLoading, setShowLoading] = useState(true);
    const [Data, setData] = useState([]);
    const [State, setState] = useState(Enum.TaskStateType.OnlyOpen);

    //--> گاید از سرور با حروف کوچک می آید ولی برای اطمینان هر دو طرف را یکسان می کنیم
    const CurrentUserId = (localStorage.getItem("UserId") || "").toLowerCase();
    //#endregion

    //#region Methods

    const Bind = (state) => {
        setShowLoading(true);
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Task/MyCartable?title=",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "state": state,
                "beginDate": '',
                "endDate": ''
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setData(res.data);
                setShowLoading(false);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize");
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied");
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoading(false);
                }
            })
    }

    const ChangeState = (value) => {
        setState(value);
        Bind(value);
    }

    const UpdateState = (taskId, state) => {
        setShowLoading(true);
        if (PopupRef.current) { PopupRef.current.close(); }
        var RequestOption = {
            method: "Post",
            url: General.ApiRoute() + "/Task/UpdateState",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                id: taskId,
                state: state
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function () {
                Bind(State);
            })
            .catch(error => {
                setShowLoading(false);
                if (error.response && error.response.status === 403) {
                    General.ShowMsg(Enum.MsgType.error, General.AccessDenied());
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                }
            })
    }

    const handleTaskProp = (Id) => {
        setShowDrawer(true);
        setTimeout(() => {
            TaskRef.current.ShowEdit(Id);
        }, 500);
        if (PopupRef.current) { PopupRef.current.close(); }
    };

    //--> گفتگوی همان وظیفه: سوال از مدیر و پاسخ ها
    const ShowChat = (Id, Title) => {
        if (PopupRef.current) { PopupRef.current.close(); }
        setShowChat(true);
        setTimeout(() => {
            ChatRef.current.Show(Id, Title);
        }, 300);
    }

    //--> فقط دیدن جزئیات، بدون فرم
    const ShowDetail = (Id) => {
        setShowDetail(true);
        setTimeout(() => {
            DetailRef.current.Show(Id);
        }, 300);
    }

    const ShowDelete = (Id) => {
        if (PopupRef.current) { PopupRef.current.close(); }
        DeleteRef.current.Show(Enum.DeleteType.Task, Id);
    }

    useEffect(() => {
        Bind(Enum.TaskStateType.OnlyOpen);
    }, [])
    //#endregion

    return (
        <Shared pageTitle={<><FaUserClock size={25} /> وظایف من</>}>
            <div align="left">
                <rsuite.Button appearance="primary" className="mb-2 ms-2"
                    onClick={() => handleTaskProp(General.GuidEmpty())}>
                    ایجاد وظیفه شخصی
                </rsuite.Button>
                <rsuite.SelectPicker
                    searchable={false}
                    cleanable={false}
                    data={[
                        { label: "وظایف باز", value: Enum.TaskStateType.OnlyOpen },
                        { label: "همه", value: Enum.TaskStateType.All },
                        { label: "در انتظار اجرا", value: Enum.TaskStateType.Waiting },
                        { label: "در حال انجام", value: Enum.TaskStateType.Doing },
                        { label: "انجام داده", value: Enum.TaskStateType.Delivered },
                        { label: "برگشت خورده", value: Enum.TaskStateType.Rejected }
                    ]}
                    value={State}
                    onChange={ChangeState}
                    style={{ width: 160 }}
                    className="mb-2"
                />
            </div>
            <rsuite.Divider />
            <ResponsiveList
                fillHeight
                data={Data}
                loading={ShowLoading}
                emptyText="وظیفه ای ندارید"
                filters={[
                    { key: 'title', label: 'عنوان', type: 'text' },
                    { key: 'projectTitle', label: 'پروژه', type: 'text' },
                    { key: 'priorityComment', label: 'اولویت', type: 'select' },
                    { key: 'stateComment', label: 'وضعیت', type: 'select' },
                    { key: 'sourceComment', label: 'تعریف شده توسط', type: 'select' }
                ]}
                renderCard={(rowData) => (
                    <>
                        <CardTitle>
                            <span className='HandCursor' style={{ color: '#2a78d6' }}
                                onClick={() => ShowDetail(rowData.id)}>
                                {rowData.title}
                            </span>
                        </CardTitle>
                        <RejectNote text={rowData.rejectComment} />
                        <CardField label="پروژه">{rowData.projectTitle} · {rowData.categoryTitle}</CardField>
                        <CardField label="اولویت">{rowData.priorityComment}</CardField>
                        <CardField label="مهلت انجام">
                            {
                                rowData.isOverdue ?
                                    <rsuite.Tag color="red">{rowData.dueDate}</rsuite.Tag>
                                    :
                                    rowData.dueDate
                            }
                        </CardField>
                        <CardField label="وضعیت">{rowData.stateComment}</CardField>
                        <CardField label="تعریف شده توسط">{rowData.sourceComment}</CardField>
                        <CardActions>
                            {/* هر وظیفه فقط یک حرکت بعدی دارد؛ دکمه ای که کلیکش
                                خطا می دهد اصلا نشان داده نمی شود */}
                            {
                                Enum.CanAgentStart(rowData.state) ?
                                    <rsuite.Button size="sm"
                                        onClick={() => UpdateState(rowData.id, Enum.TaskStateType.Doing)}>شروع کردم</rsuite.Button>
                                    :
                                    null
                            }
                            {
                                Enum.CanAgentDeliver(rowData.state) ?
                                    <rsuite.Button size="sm" appearance="primary"
                                        onClick={() => UpdateState(rowData.id, Enum.TaskStateType.Delivered)}>انجام دادم</rsuite.Button>
                                    :
                                    null
                            }
                            <rsuite.Button size="sm" appearance="ghost"
                                onClick={() => ShowChat(rowData.id, rowData.title)}>گفتگو</rsuite.Button>
                            {
                                (rowData.creatorId || "").toLowerCase() === CurrentUserId ?
                                    <>
                                        <rsuite.Button size="sm" className='ms-2'
                                            onClick={() => handleTaskProp(rowData.id)}>ویرایش</rsuite.Button>
                                        <rsuite.Button size="sm" appearance="primary" color="red" className='ms-2'
                                            onClick={() => ShowDelete(rowData.id)}>حذف</rsuite.Button>
                                    </>
                                    :
                                    null
                            }
                        </CardActions>
                    </>
                )}
            >
                <Table
                    rtl={true}
                    className='w-100'
                    bordered
                    headerHeight={40}
                    //--> ارتفاع سطر با طول عنوان بالا می رود تا عنوان بلند بریده نشود
                    rowHeight={TaskRowHeight}
                    wordWrap="break-word"
                    data={Data}
                    loading={ShowLoading}
                >
                    <Column>
                        <HeaderCell><b>ردیف</b></HeaderCell>
                        <General.RowNumber />
                    </Column>
                    <Column flexGrow={3}>
                        <HeaderCell><b>عنوان</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                <>
                                    <span className='HandCursor' style={{ color: '#2a78d6' }}
                                        onClick={() => ShowDetail(rowData.id)}>
                                        {rowData.title}
                                    </span>
                                    <RejectNote text={rowData.rejectComment} />
                                </>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={2}>
                        <HeaderCell><b>پروژه / دسته بندی</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                <>
                                    <div>{rowData.projectTitle}</div>
                                    <div>{rowData.categoryTitle}</div>
                                </>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>اولویت</b></HeaderCell>
                        <Cell dataKey="priorityComment" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>مهلت انجام</b></HeaderCell>
                        <Cell>
                            {(rowData) => (
                                rowData.isOverdue ?
                                    <rsuite.Tag color="red">{rowData.dueDate}</rsuite.Tag>
                                    :
                                    <span>{rowData.dueDate}</span>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>وضعیت</b></HeaderCell>
                        <Cell dataKey="stateComment" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>تعریف توسط</b></HeaderCell>
                        <Cell dataKey="sourceComment" />
                    </Column>
                    <Column fixed="right" className='Popup'>
                        <HeaderCell>عملیات</HeaderCell>
                        <Cell>
                            {rowData => (
                                <rsuite.Whisper
                                    placement="bottomStart"
                                    controlId="control-id-with-dropdown"
                                    trigger="click"
                                    ref={PopupRef}
                                    speaker={
                                        <rsuite.Popover full>
                                            <rsuite.Dropdown.Menu>
                                                {
                                                    Enum.CanAgentStart(rowData.state) ?
                                                        <rsuite.Dropdown.Item onClick={() => UpdateState(rowData.id, Enum.TaskStateType.Doing)}>شروع کردم</rsuite.Dropdown.Item>
                                                        :
                                                        null
                                                }
                                                {
                                                    Enum.CanAgentDeliver(rowData.state) ?
                                                        <rsuite.Dropdown.Item onClick={() => UpdateState(rowData.id, Enum.TaskStateType.Delivered)}>انجام دادم</rsuite.Dropdown.Item>
                                                        :
                                                        null
                                                }
                                                <rsuite.Dropdown.Item onClick={() => ShowChat(rowData.id, rowData.title)}>گفتگو</rsuite.Dropdown.Item>
                                                {
                                                    (rowData.creatorId || "").toLowerCase() === CurrentUserId ?
                                                        <>
                                                            <rsuite.Dropdown.Item onClick={() => handleTaskProp(rowData.id)}>ویرایش</rsuite.Dropdown.Item>
                                                            <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.id)}>حذف</rsuite.Dropdown.Item>
                                                        </>
                                                        :
                                                        null
                                                }
                                            </rsuite.Dropdown.Menu>
                                        </rsuite.Popover>
                                    }
                                >
                                    <rsuite.Button>...</rsuite.Button>
                                </rsuite.Whisper>
                            )}
                        </Cell>
                    </Column>
                </Table>
            </ResponsiveList>

            {/* روی دسکتاپ هم کشو است، نه پنجره - تقویم شمسی داخل Modal باز نمی شود */}
            <rsuite.Drawer
                open={showDrawer}
                onClose={() => setShowDrawer(false)}
                placement={isMobile ? 'bottom' : 'right'}
                size={isMobile ? 'full' : 'sm'}
            >
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>مشخصات وظیفه</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <TaskProp ref={TaskRef} onSubmit={() => { setShowDrawer(false); Bind(State); }} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>
            {/* فقط نمایش جزئیات - نه فرم */}
            <rsuite.Drawer
                open={showDetail}
                onClose={() => setShowDetail(false)}
                placement={isMobile ? 'bottom' : 'right'}
                size={isMobile ? 'full' : 'sm'}
            >
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>جزئیات وظیفه</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <TaskDetail ref={DetailRef} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>

            {/* گفتگوی وظیفه */}
            <rsuite.Drawer
                open={showChat}
                onClose={() => setShowChat(false)}
                placement={isMobile ? 'bottom' : 'right'}
                size={isMobile ? 'full' : 'sm'}
            >
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>گفتگو</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <TaskConversation ref={ChatRef} onSent={() => setShowChat(false)} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>

            <Delete ref={DeleteRef} onSubmit={() => Bind(State)} />
        </Shared>
    );
}

export default MyTasks;
